import Layout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/Home/Activities';
import { displayName } from '../../../config';

const Activities = (): JSX.Element => {
  document.title = `${displayName}: Activities`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default Activities;
